import React from 'react';
import VMasker from 'vanilla-masker';
import {
  FormGroup,
  Label,
  Input,
  ErrorMessage,
  LoadingSpinner,
  AutoFillBadge,
} from '../../styles';
import styled from 'styled-components';

const InputWrapper = styled.div`
  position: relative;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
`;

interface MobileInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel' | 'number' | 'date';
  mask?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  loading?: boolean;
  autoFilled?: boolean;
  maxLength?: number;
  inputMode?: 'text' | 'numeric' | 'email' | 'tel' | 'decimal';
}

const MobileInput: React.FC<MobileInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  mask,
  required,
  error,
  disabled,
  loading,
  autoFilled,
  maxLength,
  inputMode,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    if (mask) {
      // Apply mask using VMasker
      const rawValue = newValue.replace(/\D/g, '');
      newValue = VMasker.toPattern(rawValue, mask);
    }

    onChange(newValue);
  };

  return (
    <FormGroup>
      <LabelRow>
        <Label required={required}>{label}</Label>
        {autoFilled && <AutoFillBadge>✓ Preenchido</AutoFillBadge>}
      </LabelRow>
      <InputWrapper>
        <Input
          type={type}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled || loading}
          hasError={!!error}
          maxLength={maxLength}
          inputMode={inputMode}
        />
        {loading && (
          <SpinnerWrapper>
            <LoadingSpinner />
          </SpinnerWrapper>
        )}
      </InputWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormGroup>
  );
};

export default MobileInput;
